import React from "react";
import IconButton from "@mui/material/IconButton";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import "./navbar.scss";

// Sidebar is a permanent rail on desktop, so this only needs to exist to open
// the temporary drawer on mobile — everything else that used to live in the
// header (account info, page title) has moved into the sidebar itself.
// Skip rendering entirely on desktop rather than just hiding it with CSS —
// MUI injects its own runtime styles which can win a display:none fight.
function Navbars({ toggleSidebar }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

  if (!isMobile) return null;

  return (
    <IconButton className="mobile-menu-btn" onClick={toggleSidebar} aria-label="Open menu">
      <MenuIcon />
    </IconButton>
  );
}

export default Navbars;
